import useComparativeStudyComparisons from '../../../App/hooks/useComparativeStudyComparisons';

import { useState } from 'react';
import AdsTable from '../../../features/ad/components/adsTable/AdsTable';
import { similariesTableHeader } from '../../../features/ad/constant';
import IndividualCircularLoader from '../../Loader/IndividualCircularLoader';

const display = 20;

interface IComparisonContentProps {
  count: number;
}

const ComparisonsContent = ({ count }: IComparisonContentProps) => {
  const { comparisonsActiveTab, lists } = useComparativeStudyComparisons();
  const [minIndexTab, setMinIndexTab] = useState<number>(0);

  return (
    <>
      {!lists[comparisonsActiveTab] && count !== 0 ? (
        <IndividualCircularLoader size={100} />
      ) : lists[comparisonsActiveTab]?.length ? (
        <AdsTable
          columnTitles={similariesTableHeader}
          ads={lists[comparisonsActiveTab]}
          needCheck={true}
          display={display}
          minIndexTab={minIndexTab}
        />
      ) : (
        <p className="no-content">Aucune annonce Pour cette catégorie</p>
      )}
    </>
  );
};

export default ComparisonsContent;
